import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getSpecializationList = async () => {
    const { path, method } = endpoints.educationCareerPath.getSpecializationList;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
      method,
      {},
      {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
